import { Button, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    i18n.changeLanguage(currentLang === 'sv' ? 'en' : 'sv');
  };

  return (
    <Button variant="ghost" size="sm" onClick={toggleLanguage} px={2}>
      <Flex gap={1} alignItems="center">
        <Text
          fontWeight={currentLang === 'en' ? 'bold' : 'normal'}
          opacity={currentLang === 'en' ? 1 : 0.5}
        >
          EN
        </Text>
        <Text opacity={0.5}>|</Text>
        <Text
          fontWeight={currentLang === 'sv' ? 'bold' : 'normal'}
          opacity={currentLang === 'sv' ? 1 : 0.5}
        >
          SV
        </Text>
      </Flex>
    </Button>
  );
}

export default LanguageSwitcher;
